import { DocumentManage } from '@/utils/commonUtil'

// 元素附加信息定义
class ElAttachInfo {
  constructor(el, binding, vnode) {
    this.updateProperties(el, binding, vnode)
    this.dataSize = 0
    this.rowHeight = 0
    this.showRowNum = 0
    this.topNum = 0
    this.maxTopNum = 0
    this.timerId = 0
    this.refreshFlag = false
    this.documentManage = new DocumentManage()
    this.documentManage.set('onScroll', e => {
      this.onScroll(e)
    })
    this.documentManage.set('onWindowResize', e => {
      this.onWindowResize(e)
    })
  }
  updateProperties(el, binding, vnode) {
    this.el = el
    this.binding = binding
    this.vnode = vnode
  }
  init() {
    this.dataSize = this.vnode.data.attrs['data-size']
    if (this.dataSize === 0) {
      return
    }
    const selectWrap = this.el.querySelector('.el-table__body-wrapper')
    const selectTbody = selectWrap.querySelector('table tbody')
    this.refreshRowHeight()
    this.showRowNum = Math.round(this.getTableBodyHeight() / this.rowHeight)
    this.topNum = 0
    this.maxTopNum = this.dataSize - this.showRowNum - 1
    if (this.maxTopNum < 0) {
      this.maxTopNum = 0
    }
    selectTbody.setAttribute('style', `transform: translateY(0px)`)
    let placeholderTr = selectTbody.querySelector('.placeholder-tr')
    let placeholderHeight = (this.dataSize - this.showRowNum - 1) * this.rowHeight
    if (placeholderHeight < 0) {
      placeholderHeight = 0
    }
    if (placeholderTr) {
      placeholderTr.setAttribute('style', `height: ${placeholderHeight}px;`)
    } else {
      placeholderTr = document.createElement('tr')
      placeholderTr.setAttribute('class', 'placeholder-tr')
      placeholderTr.setAttribute('style', `height: ${placeholderHeight}px;`)
      selectTbody.append(placeholderTr)
    }
    /* 重置滚动后的事件监听 */
    selectWrap.removeEventListener('scroll', this.documentManage.get('onScroll'))
    selectWrap.addEventListener('scroll', this.documentManage.get('onScroll'))
  }
  refreshRowHeight() {
    const selectWrap = this.el.querySelector('.el-table__body-wrapper')
    const selectRow = selectWrap.querySelector('table tr')
    if (!selectRow) {
      return
    }
    this.rowHeight = selectRow.clientHeight
  }
  getTableBodyHeight() {
    const header = this.el.querySelector('.el-table__header-wrapper')
    return this.el.clientHeight - header.clientHeight
  }
  onScroll() {
    if (this.dataSize === 0) {
      return
    }
    const selectWrap = this.el.querySelector('.el-table__body-wrapper')
    const selectTbody = selectWrap.querySelector('table tbody')
    const placeholderTr = selectTbody.querySelector('.placeholder-tr')
    if (!placeholderTr) {
      return
    }
    if (this.refreshFlag) {
      this.refreshFlag = false
      this.refreshRowHeight()
      this.showRowNum = Math.round(this.getTableBodyHeight() / this.rowHeight)
      this.maxTopNum = this.dataSize - this.showRowNum - 1
      if (this.maxTopNum < 0) {
        this.maxTopNum = 0
      }
    }
    this.topNum = Math.floor(selectWrap.scrollTop / this.rowHeight)
    if (this.topNum > this.maxTopNum) {
      this.topNum = this.maxTopNum
    }
    selectTbody.setAttribute('style', `transform: translateY(${this.topNum * this.rowHeight}px)`)
    let placeholderHeight = (this.dataSize - this.topNum - this.showRowNum - 1) * this.rowHeight
    if (placeholderHeight < 0) {
      placeholderHeight = 0
    }
    placeholderTr.setAttribute('style', `height: ${placeholderHeight}px;`)
    if (this.timerId > 0) {
      clearTimeout(this.timerId)
    }
    this.timerId = setTimeout((startIndex, endIndex, showRowNum) => {
      this.binding.value.call(null, startIndex, endIndex, showRowNum)
    }, 0, this.topNum, this.topNum + this.showRowNum, this.showRowNum)
  }
  onWindowResize() {
    if (this.el.style.display === 'none') {
      this.refreshFlag = true
      const selectWrap = this.el.querySelector('.el-table__body-wrapper')
      const selectTbody = selectWrap.querySelector('table tbody')
      const placeholderTr = selectTbody.querySelector('.placeholder-tr')
      if (!placeholderTr) {
        return
      }
      let placeholderHeight = (this.dataSize - this.topNum - 50 - 1) * this.rowHeight
      if (placeholderHeight < 0) {
        placeholderHeight = 0
      }
      placeholderTr.setAttribute('style', `height: ${placeholderHeight}px;`)
      if (this.timerId > 0) {
        clearTimeout(this.timerId)
      }
      this.timerId = setTimeout((startIndex, endIndex, showRowNum) => {
        this.binding.value.call(null, startIndex, endIndex, showRowNum)
      }, 0, this.topNum, this.topNum + 50, 50)
      return
    }
    this.init()
    this.onScroll()
  }
}

// 元素附加信息集合
const elAttachInfoMap = new Map()

export default {
  bind(el, binding, vnode) {
    const attachInfo = new ElAttachInfo(el, binding, vnode)
    elAttachInfoMap.set(vnode.componentInstance._uid, attachInfo)
    window.addEventListener('resize', attachInfo.documentManage.get('onWindowResize'))
  },
  componentUpdated(el, binding, vnode) {
    const attachInfo = elAttachInfoMap.get(vnode.componentInstance._uid)
    attachInfo.updateProperties(el, binding, vnode)
    const dataSize = vnode.data.attrs['data-size']
    const heightChangeFlag = vnode.data.attrs['height-change-flag']
    if (dataSize !== attachInfo.dataSize || heightChangeFlag) {
      if (attachInfo.el.style.display === 'none') {
        attachInfo.refreshFlag = true
      } else {
        setTimeout(() => {
          attachInfo.init()
          attachInfo.onScroll()
        })
      }
    }
  },
  unbind(el, binding, vnode) {
    const attachInfo = elAttachInfoMap.get(vnode.componentInstance._uid)
    window.removeEventListener('resize', attachInfo.documentManage.get('onWindowResize'))
    elAttachInfoMap.delete(vnode.componentInstance._uid)
  }
}
